import { defineComponent as v, useSlots as _, ref as b, computed as t, openBlock as i, createElementBlock as o, normalizeClass as r, createVNode as k, unref as y, createCommentVNode as s, renderSlot as c, createElementVNode as V, toDisplayString as z } from "vue";
import { CheckIcon as $ } from "@frontiers/brink-icons";
import './assets/index40.css';const g = ["disabled", "aria-pressed"], B = { class: "ChipFilter__label" }, w = /* @__PURE__ */ v({
  __name: "ChipFilter",
  props: {
    color: { default: "black" },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    size: { default: "md" },
    modelValue: { type: Boolean, default: !1 },
    showTick: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(h, { expose: m, emit: C }) {
    const l = h, a = _(), d = b(null);
    m({
      button: d
    });
    const F = {
      xl: "lg",
      lg: "md",
      md: "md",
      sm: "sm"
    }, n = t(() => F[l.size]), p = t(
      () => !l.showTick && !!a.icon && !a.avatar
    );
    function f() {
      l.disabled || l.readonly || C("update:modelValue", !l.modelValue);
    }
    const u = t(() => !!a.avatar && a.avatar().length > 0);
    return (e, I) => (i(), o("button", {
      ref_key: "chipFilterRef",
      ref: d,
      class: r(["ChipFilter", [
        `ChipFilter--${e.size}`,
        `ChipFilter--${e.color}`,
        {
          "ChipFilter--selected": e.modelValue,
          "ChipFilter--disabled": e.disabled,
          "ChipFilter--readonly": e.readonly,
          "ChipFilter--hasTickIcon": e.showTick && e.modelValue,
          "ChipFilter--hasIcon": p.value,
          "ChipFilter--hasAvatar": u.value
        }
      ]]),
      disabled: e.disabled,
      "aria-pressed": e.modelValue,
      onClick: f
    }, [
      e.showTick && e.modelValue ? (i(), o("div", {
        key: 0,
        class: r(["ChipFilter__tickIcon", `ChipFilter__icon--${e.size}`])
      }, [
        k(y($), { size: n.value }, null, 8, ["size"])
      ], 2)) : s("", !0),
      u.value ? (i(), o("div", {
        key: 1,
        class: r(["ChipFilter__avatar", [
          `ChipFilter__avatar--${e.size}`,
          `ChipFilter__avatar--${e.color}`,
          {
            "ChipFilter__avatar--selected": e.modelValue,
            "ChipFilter__avatar--disabled": e.disabled
          }
        ]])
      }, [
        c(e.$slots, "avatar")
      ], 2)) : s("", !0),
      p.value ? (i(), o("div", {
        key: 2,
        class: r(["ChipFilter__icon", [
          `ChipFilter__icon--${e.size}`,
          {
            "ChipFilter__icon--selected": e.modelValue
          }
        ]])
      }, [
        c(e.$slots, "icon", {
          size: n.value,
          fill: "currentColor"
        })
      ], 2)) : s("", !0),
      V("span", B, z(e.label), 1)
    ], 10, g));
  }
});
export {
  w as ChipFilter
};
